import { Module } from 'vuex';

/** Helps keep vuex module types in typescript */
export function defineModule<S, T>(module: T & Module<S, {}>): T {
  return module;
}

export default defineModule;
